import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "result", "fields"]
  static values = { url: String }

  open() {
    this.panelTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.panelTarget.classList.add("hidden")
    document.body.style.overflow = ""
    if (this.hasResultTarget) this.resultTarget.classList.add("hidden")
  }

  removeField(event) {
    event.target.closest(".test-field-row")?.remove()
  }

  addField() {
    const row = document.createElement("div")
    row.className = "test-field-row grid grid-cols-[1fr_2fr_auto] gap-2 items-center"
    row.innerHTML = `
      <input type="text" class="test-field-name px-2.5 py-2 text-sm rounded-md border border-gray-300 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="field name">
      <input type="text" class="test-field-value px-2.5 py-2 text-sm rounded-md border border-gray-300 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="value">
      <button type="button" class="remove-field p-2 text-gray-400 hover:text-rose-600" title="Remove" data-action="test-panel#removeField">
        <svg class="h-4 w-4 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/></svg>
      </button>`
    this.fieldsTarget.appendChild(row)
    row.querySelector(".test-field-name").focus()
  }

  async submit(event) {
    const submitButton = event.currentTarget
    const formData = new FormData()

    this.fieldsTarget.querySelectorAll(".test-field-row").forEach((row) => {
      const name = row.querySelector(".test-field-name")?.value?.trim()
      const value = row.querySelector(".test-field-value")?.value ?? ""
      if (name) formData.append(`form_data[${name}]`, value)
    })

    submitButton.disabled = true
    const originalLabel = submitButton.textContent
    submitButton.textContent = "Sending..."
    this.resultTarget.classList.add("hidden")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          "Accept": "application/json"
        },
        body: formData
      })
      const body = await response.json()

      if (response.ok && body.success) {
        this.resultTarget.className = "mt-6 rounded-lg border p-4 text-sm bg-emerald-50 border-emerald-200 text-emerald-800"
        this.resultTarget.innerHTML = `<div class="font-medium">Submission received (${body.elapsed_ms} ms)</div>
          <p class="mt-1">Submission ${body.submission_id} created. Notifications are firing in the background.</p>
          <a href="${body.submission_url}" class="mt-2 inline-block underline font-medium">View submission</a>`
      } else {
        this.resultTarget.className = "mt-6 rounded-lg border p-4 text-sm bg-rose-50 border-rose-200 text-rose-800"
        this.resultTarget.textContent = `Failed: ${body.error || `HTTP ${response.status}`}`
      }
    } catch (error) {
      this.resultTarget.className = "mt-6 rounded-lg border p-4 text-sm bg-rose-50 border-rose-200 text-rose-800"
      this.resultTarget.textContent = `Network error: ${error.message}`
    } finally {
      this.resultTarget.classList.remove("hidden")
      submitButton.disabled = false
      submitButton.textContent = originalLabel
    }
  }
}
